<div class="almacen main-content no-sidebar">
  <main class="workspace" id="main-content">
    <div class="workspace-header">
      <h1>Almacén de certificados</h1>
      <p>Certificados detectados en el almacén de certificados de Windows (complemento local)</p>
    </div>

    <!-- Cargando o complemento no detectado -->
    <div *ngIf="showNotAvailableView" class="step-container token-fisico-not-available" role="status" aria-live="polite">
      <div class="token-fisico-not-available-inner">
        <div *ngIf="loading" class="token-fisico-checking">
          <span class="spinner" aria-hidden="true"></span>
          <p>Consultando almacén de certificados…</p>
        </div>
        <ng-container *ngIf="!loading">
          <div class="token-fisico-not-available-icon" aria-hidden="true">
            <i class="fas fa-database"></i>
          </div>
          <h2 class="token-fisico-not-available-title">Complemento no detectado</h2>
          <p class="token-fisico-not-available-message">
            Para ver el almacén de certificados de Windows es necesario tener en ejecución el complemento local en tu equipo.
          </p>
          <div class="token-fisico-not-available-actions">
            <a [href]="agentDownloadUrl" target="_blank" rel="noopener" class="btn btn-primary" *ngIf="agentDownloadUrl.startsWith('http')" aria-label="Obtener complemento">
              <i class="fas fa-download" aria-hidden="true"></i>
              Obtener complemento
            </a>
            <button type="button" class="btn btn-primary" (click)="loadCertificates()" aria-label="Actualizar">
              <i class="fas fa-rotate" aria-hidden="true"></i>
              Actualizar
            </button>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- Sin certificados -->
    <div *ngIf="showEmptyState" class="step-container token-fisico-not-available tf-no-tokens" role="status" aria-live="polite">
      <div class="token-fisico-not-available-inner">
        <div class="token-fisico-not-available-icon tf-icon-info" aria-hidden="true">
          <i class="fas fa-folder-open"></i>
        </div>
        <h2 class="token-fisico-not-available-title">No hay certificados</h2>
        <p class="token-fisico-not-available-message">
          No se encontraron certificados en el almacén o el complemento no pudo leerlos.
        </p>
        <div class="token-fisico-not-available-actions">
          <button type="button" class="btn btn-primary" (click)="loadCertificates()" aria-label="Volver a consultar">
            <i class="fas fa-rotate" aria-hidden="true"></i>
            Actualizar
          </button>
        </div>
      </div>
    </div>

    <!-- Lista de certificados con tabs -->
    <div *ngIf="showCertificateList" class="almacen-list">
      <p class="almacen-subtitle">Certificados en el almacén ({{ certificates.length }})</p>
      <div class="certificate-list">
        <div
          class="certificate-item cert-card"
          *ngFor="let cert of certificates; let i = index"
          role="article"
          [attr.aria-label]="'Certificado ' + (i + 1) + ': ' + displayName(cert)">
          <div class="cert-card-header">
            <p class="certificate-title">{{ displayName(cert) }}</p>
            <span class="certificate-badge badge-caducado" *ngIf="cert.notAfter && isExpired(cert.notAfter)">
              Certificado caducado
            </span>
            <span class="certificate-badge badge-vigente" *ngIf="cert.notAfter && !isExpired(cert.notAfter)">
              Vigente
            </span>
            <span class="certificate-badge badge-keystore" *ngIf="cert.source">Almacén</span>
          </div>

          <div class="cert-tabs" role="tablist">
            <button type="button" role="tab" [attr.aria-selected]="getActiveTab(i) === 0" [class.active]="getActiveTab(i) === 0" (click)="setActiveTab(i, 0)">General</button>
            <button type="button" role="tab" [attr.aria-selected]="getActiveTab(i) === 1" [class.active]="getActiveTab(i) === 1" (click)="setActiveTab(i, 1)">Titular y emisor</button>
            <button type="button" role="tab" [attr.aria-selected]="getActiveTab(i) === 2" [class.active]="getActiveTab(i) === 2" (click)="setActiveTab(i, 2)">Técnico</button>
            <button type="button" role="tab" [attr.aria-selected]="getActiveTab(i) === 3" [class.active]="getActiveTab(i) === 3" (click)="setActiveTab(i, 3)">Ruta de certificación</button>
          </div>

          <div class="tab-panes">
            <div class="tab-pane" *ngIf="getActiveTab(i) === 0" role="tabpanel">
              <dl class="certificate-data-list">
                <dt>Emisor</dt>
                <dd>{{ extractIssuerName(cert.issuerDN) || '—' }}</dd>
                <dt>Número de serie</dt>
                <dd class="cert-value-monospace">{{ cert.serialNumber || '—' }}</dd>
                <dt>Válido desde</dt>
                <dd>{{ formatDate(cert.notBefore) || '—' }}</dd>
                <dt>Válido hasta</dt>
                <dd [class.cert-expired]="cert.notAfter && isExpired(cert.notAfter)">{{ formatDate(cert.notAfter) || '—' }}</dd>
                <dt>Clave privada</dt>
                <dd>{{ cert.hasPrivateKey ? 'Sí' : 'No' }}</dd>
              </dl>
            </div>
            <div class="tab-pane" *ngIf="getActiveTab(i) === 1" role="tabpanel">
              <p class="cert-field-label">Subject (titular)</p>
              <ul class="dn-list" *ngIf="parseDN(cert.subjectDN).length; else emptySubject">
                <li class="dn-item" *ngFor="let item of parseDN(cert.subjectDN)">
                  <span class="dn-key" *ngIf="item.key">{{ item.key }}:</span>
                  <span class="dn-value">{{ item.value }}</span>
                </li>
              </ul>
              <ng-template #emptySubject><p class="dn-empty">—</p></ng-template>
              <p class="cert-field-label">Issuer (emisor)</p>
              <ul class="dn-list" *ngIf="parseDN(cert.issuerDN).length; else emptyIssuer">
                <li class="dn-item" *ngFor="let item of parseDN(cert.issuerDN)">
                  <span class="dn-key" *ngIf="item.key">{{ item.key }}:</span>
                  <span class="dn-value">{{ item.value }}</span>
                </li>
              </ul>
              <ng-template #emptyIssuer><p class="dn-empty">—</p></ng-template>
            </div>
            <div class="tab-pane" *ngIf="getActiveTab(i) === 2" role="tabpanel">
              <dl class="certificate-data-list">
                <dt>Thumbprint</dt>
                <dd class="cert-value-monospace">{{ cert.thumbprint || '—' }}</dd>
                <dt>Número de serie</dt>
                <dd class="cert-value-monospace">{{ cert.serialNumber || '—' }}</dd>
                <dt>Algoritmo</dt>
                <dd>{{ cert.keyAlgorithm || '—' }}{{ cert.keySize ? ' · ' + cert.keySize + ' bits' : '' }}</dd>
                <dt>Válido desde</dt>
                <dd>{{ formatDate(cert.notBefore) || '—' }}</dd>
                <dt>Válido hasta</dt>
                <dd [class.cert-expired]="cert.notAfter && isExpired(cert.notAfter)">{{ formatDate(cert.notAfter) || '—' }}</dd>
                <dt>Clave privada</dt>
                <dd>{{ cert.hasPrivateKey ? 'Sí' : 'No' }}</dd>
                <dt>Válido (estado)</dt>
                <dd>{{ cert.isValid === true ? 'Sí' : cert.isValid === false ? 'No' : '—' }}</dd>
                <dt>Origen</dt>
                <dd>{{ cert.source || '—' }}</dd>
              </dl>
            </div>
            <div class="tab-pane" *ngIf="getActiveTab(i) === 3" role="tabpanel">
              <p class="cert-field-label">Ruta de certificación</p>
              <ng-container *ngIf="getCertificationPathOrdered(cert).length; else noCertPath">
                <div class="cert-path-tree">
                  <button
                    type="button"
                    class="cert-path-item"
                    *ngFor="let node of getCertificationPathOrdered(cert); let pathIdx = index"
                    [class.titular]="isTitularInPath(getCertificationPathOrdered(cert), pathIdx)"
                    [class.selected]="getSelectedPathNode(i)?.thumbprint === node.thumbprint"
                    (click)="selectPathNode(i, getSelectedPathNode(i)?.thumbprint === node.thumbprint ? null : node)"
                    [attr.aria-label]="'Nivel ' + pathIdx + ': ' + node.friendlyName">
                    <span class="cert-path-icon" aria-hidden="true"><i class="fas fa-certificate"></i></span>
                    <span class="cert-path-name">{{ node.friendlyName }}</span>
                    <span class="cert-path-root-badge" *ngIf="node.isRoot">Raíz</span>
                  </button>
                </div>
                <div class="cert-path-detail" *ngIf="getSelectedPathNode(i) as node">
                  <p class="cert-field-label">Detalle del certificado seleccionado</p>
                  <dl class="certificate-data-list cert-path-detail-list">
                    <dt>Subject</dt>
                    <dd class="cert-path-dn">
                      <ul class="dn-list">
                        <li class="dn-item" *ngFor="let item of parseDN(node.subjectDN)">
                          <span class="dn-key" *ngIf="item.key">{{ item.key }}:</span>
                          <span class="dn-value">{{ item.value }}</span>
                        </li>
                      </ul>
                    </dd>
                    <dt>Issuer</dt>
                    <dd class="cert-path-dn">
                      <ul class="dn-list">
                        <li class="dn-item" *ngFor="let item of parseDN(node.issuerDN)">
                          <span class="dn-key" *ngIf="item.key">{{ item.key }}:</span>
                          <span class="dn-value">{{ item.value }}</span>
                        </li>
                      </ul>
                    </dd>
                    <dt>Serial</dt>
                    <dd class="cert-value-monospace">{{ node.serialNumber }}</dd>
                    <dt>Thumbprint</dt>
                    <dd class="cert-value-monospace">{{ node.thumbprint }}</dd>
                    <dt>Válido desde</dt>
                    <dd>{{ formatDate(node.notBefore) }}</dd>
                    <dt>Válido hasta</dt>
                    <dd [class.cert-expired]="isExpired(node.notAfter)">{{ formatDate(node.notAfter) }}</dd>
                  </dl>
                  <button type="button" class="btn-link-sm" (click)="selectPathNode(i, null)">Cerrar detalle</button>
                </div>
              </ng-container>
              <ng-template #noCertPath>
                <p class="dn-empty">No hay ruta de certificación disponible.</p>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
      <div class="almacen-actions">
        <button type="button" class="btn btn-secondary" (click)="loadCertificates()" aria-label="Actualizar lista">
          <i class="fas fa-rotate" aria-hidden="true"></i>
          Actualizar
        </button>
      </div>
    </div>
  </main>
</div>
